import React from "react";
import StationsTable from "../components/Tables/StationsTable";
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import CircularProgress from '@material-ui/core/CircularProgress';
import StationModal from '../components/Modals/StationModal';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography'
import TableTop from '../components/Tables/TableSiteTop';
import { loadStationPumps } from "../actions/stationActions";
import compose from 'recompose/compose';
import { modalToggle } from '../actions/modalActions';
import  SnackbarMessage  from '../components/Layout/SnackbarMessage';
import { deleteStation } from '../actions/stationActions';
import { addStationsSearchCriteria } from '../actions/searchActions';

const styles = theme => ({
  root: {
    flexGrow: 1,
    padding: 8,
    margin: 8
  },
  progress: {
    margin: theme.spacing.unit * 2,
  },
});

class StationsPage extends React.Component {
  componentDidMount() {
    const { loadStationPumps } = this.props;
    loadStationPumps();
  }

  state = {
    isModalOpen: false,
    // The modal is used for editing and creating.
    // Thus, the modal needs the information, which
    // functionality is to be used.
    useEditModal: false,
    // When clicking a table row, the row is hilighted and modal opened.
    // This property is used for removing the hilight when modal is closed.
    useSelectedRow: true,
    selectedStation: null
  }

  handleCreateModalOpen = () => {
    this.setState({ isModalOpen: true });
    this.props.modalToggle(true);
  };

  handleCreateModalClose = () => {
    this.setState({ isModalOpen: false, useEditModal: false, useSelectedRow: false, selectedStation: null });
    this.props.modalToggle(false);
  };

  handleEditClick = (station) => {
    this.props.modalToggle(true);
    this.setState({isModalOpen: true, useEditModal: true, useSelectedRow: true, selectedStation: station});
  }

  handleStationDelete = async (station) => {
    if (this.props.isDeleting ) {
      return;
    }
    this.setState({ useSelectedRow: true, selectedStation: station});
    let ans = window.confirm(
      "Caution! Keep in mind that by deleting the wanted station pump will also delete the whole station and all the pumps in that station.\n\nCaution! If there are any terminals that are located in these terminal pumps, those location must be changed before deleting.\n\n\n" +
      "Are you sure you want to delete the terminal and the terminal pumps related to that terminal?");
    if(ans) {
      await this.props.deleteStation(station);
    }
    this.setState({ useSelectedRow: false, selectedStation: null});
  }

  handleSearchFieldChange = (searchCriteria) => {
    this.props.addStationsSearchCriteria(searchCriteria);
  }

  render() {
    const {classes, stationPumps, role} = this.props;
    const { isModalOpen, useEditModal, useSelectedRow, selectedStation } = this.state;
    const { handleCreateModalOpen, handleCreateModalClose } = this;

    return (
      <div className={classes.root}>
        <TableTop role={role} handleModalOpen={handleCreateModalOpen} isButtonDisabled={(stationPumps.isLoading || stationPumps.hasErrored)} headlineText="Stations / Pumps"/>
        <Grid container spacing={24} alignItems="center">
      {stationPumps.hasFailed && (
        <Grid item xs={12}>
          <Typography>Error</Typography>
        </Grid>
      )}
      {stationPumps.isLoading && (
        <Grid item xs={12}>
          <CircularProgress className={classes.progress} size={50} />
        </Grid>
      )}
      {stationPumps.stationPumpsData != null && stationPumps.stationPumpsData.length > 0 && (
        <Grid item xs={12}>
          <StationsTable
            role={role}
            handleStationDelete={this.handleStationDelete}
            useSelectedRow={useSelectedRow}
            handleEditClick={this.handleEditClick}
            stations={stationPumps.stationPumpsData}
            handleSearchFieldChange={this.handleSearchFieldChange}
            searchFieldValues={this.props.searchFieldValues.stations}
          />
        </Grid>
      )}
      </Grid>
      <StationModal selectedStation={selectedStation} isEdit={useEditModal} isOpen={isModalOpen} handleClose={handleCreateModalClose}/>
      <SnackbarMessage autoHideDuration={10000}/>
    </div>

    )
  }
}

StationsPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {
    stationPumps: state.stationPump.stationPumps,
    isDeleting: state.stationPump.stationPumps.isDeleting,
    searchFieldValues: state.searchField,
    role: (state.oidc.user && state.oidc.user.profile) ? state.oidc.user.profile.identity_role : null,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadStationPumps: () => {
      dispatch(loadStationPumps())
    },
    modalToggle: (value) => {
      dispatch(modalToggle(value));
    },
    deleteStation: (station) => {
      dispatch(deleteStation(station))
    },
    addStationsSearchCriteria: (searchField) => {
      dispatch(addStationsSearchCriteria(searchField))
    }
  }
}

export default
  compose(
    withStyles(styles),
    connect(mapStateToProps, mapDispatchToProps)
  )(StationsPage);



// WEBPACK FOOTER //
// ./src/containers/StationsPage.js